import { FunctionComponent } from "react";
import { useTranslation } from "react-i18next";

import { ScoreCriteriaType } from "../../schema/score.schema";
import { RowPreview } from "../../shell/RowPreview";
import { CellAssignment, PersonaView, SegmentView } from "../../shell/scoreConfigView";
import { ScoreIssue } from "../../shell/scoreIssues";

interface SegmentPreviewProps {
	segment: SegmentView;
	/** The personas that exist in the segment, with the scoring each one gets there. */
	rows: { persona: PersonaView; assignment: CellAssignment | null }[];
	criteria: ScoreCriteriaType[];
	issues: ScoreIssue[];
}

/** The hover card of a segment chip (PREC-4055): its personas and their lead scoring. */
export const SegmentPreview: FunctionComponent<SegmentPreviewProps> = ({
	segment,
	rows,
	criteria,
	issues,
}) => {
	const { t } = useTranslation();

	return (
		<RowPreview
			criteria={criteria}
			description={segment.description}
			emptyPairs={t("leadScoring.segments.noPersonaYet")}
			issues={issues}
			pairs={rows.map(({ persona, assignment }) => ({
				key: `${persona.id}`,
				label: persona.name,
				assignment,
			}))}
			pairsTitle={t("leadScoring.segments.personasAndScoring")}
			testId={`segment-preview-${segment.key}`}
			title={segment.name}
		/>
	);
};
